<p-menubar [model]="items" styleClass="flex justify-between">
  @if (displayLogo) {
    <ng-template pTemplate="start">
      @if (items.length > 0) {
        <img
          [class]="logoClass"
          width="120"
          height="68"
          routerLink="/"
          [src]="logoSrc"
          [alt]="logoAlt"
        />
      } @else {
        <img
          [class]="logoClass"
          [src]="logoSrc"
          width="120"
          height="68"
          [alt]="logoAlt"
        />
      }
    </ng-template>
  }
</p-menubar>
